import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import Button from '@wix/da-shared-react/pkg/Button';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiComment, PapiUser } from '@wix/da-types-papi';
import { CommentSubject } from './types';
import {
  withLogBiEvent,
  WithLogBiEventProps,
} from '@wix/da-shared-react/pkg/biLogger/hocs/withLogBiEvent';
import { BiEventType } from '@wix/da-shared-react/pkg/biLogger';
import { CommentableTypes } from '@wix/da-shared-react/pkg/CommentThread';
import MyComment from './MyComment';

import s from './MyComments.scss';

export interface Props {
  moduleId: number;
  isOwner: boolean;
  items: {
    subject: CommentSubject;
    comment: PapiComment;
  }[];
  hasMore: boolean;
  isFetching: boolean;
  className?: string;
  fetchMore?: () => void;
  profileOwnerUser: PapiUser;
}

const enhance = compose(
  withTranslation(),
  withLogBiEvent
);
export class MyComments extends React.Component<
  Props & WithLogBiEventProps & WithTranslation
> {
  render() {
    const { hasMore, items, isOwner, t } = this.props;
    return (
      <div className={classnames(s['root'], this.props.className)}>
        <div className={s['comments']}>
          {items &&
            items
              .filter(item => !!item.comment)
              .map(({ subject, comment }, idx) => (
                <MyComment
                  className={s['item']}
                  subject={subject}
                  comment={comment}
                  isOwner={isOwner}
                  key={idx}
                />
              ))}
        </div>
        {items && hasMore && (
          <Button view="b8" onClick={this.onClickLoadMore} fullWidth>
            {t!('common.loadMore')}
          </Button>
        )}
      </div>
    );
  }

  onClickLoadMore = () => {
    const { fetchMore, logBiEvent, profileOwnerUser } = this.props;
    logBiEvent({
      evid: BiEventType.PROFILE_LOAD_MORE_CLICK,
      itemid: profileOwnerUser.userId,
      typeid: CommentableTypes.COMMENT_USER,
    });
    fetchMore && fetchMore();
  };
}

export default enhance(MyComments) as React.ComponentType<Props>;
